<template>
    <div id="body" class="body-main">
        <div id="portfolio-feature-wrap" class="portfolio-feature-wrap-main" v-if="loaded">
            <div id="portfolio-feature">
                <div :id="FrameID()" class="frame-main" :style="`background-image: url(${profileContent.backgroundImage});`">
                    <div v-if="!welcomeComplete && loaded">
                        <Logo
                            type="Intro"
                            :size="400"
                            @loaded="WelcomeComplete()"
                        />
                    </div>
                    <div v-else>
                        <Header :mobile="platform.mobile" @sub-navigation-navigate="$emit('sub-navigation-navigate', $event)"/>

                        <!-- Profile - Main -->
                        <div id="frame-body" v-if="profileContent.content === profile.defaultLandingPage">
                            <div id="introduction" class="flex-x-center m-row">
                                <div id="statement-wrap" class="column flex-center m-span">
                                    <div>
                                        <p id="statement">As a <span class="emphasize-i">creative</span>, I focus my efforts on providing social impact for our communities. Browse projects using the timeline and note the prior experience that developed my skillset that I now apply toward <span class="emphasize-i">solutions I care about</span>.</p>
                                        <img class="icon m-align-r" src="@/assets/Images/Signature.png" alt="Signature" title="Signature" width="150" height="54"/>
                                    </div>
                                </div>
                                <div class="divider" v-if="platform.mobile"></div>
                                <div class="column m-margin-align-c m-no-pad m-span" v-for="(button, b) in Navigation.Projects.PriorityTypes" :key="b">
                                    <PriorityButton :priority="button" @select="SelectProjectPriorityType($event)"/>
                                </div>
                            </div>
                        </div>

                        <!-- Profile - Palette Summary -->
                        <ProfilePaletteSummary
                            v-if="profileContent.content === PROFILES.paletteSummary && analysis.palette.usage"
                            :usageProfile="analysis.palette.usage"
                        />

                    </div>
                </div>
                <Timeline
                    v-if="ShowAttachedTimeline()"
                    :timeline="timeline"
                    @navigate="ASSETS.Timeline.Navigation.Navigate(this, $event)"
                    @configure="ASSETS.Timeline.Configure(this, $event)"
                    @max-topography="SetTimelineProjectsMaxTopography($event)"
                />
            </div>
        </div>
        <Timeline
            v-if="ShowDetachedTimeline()"
            :timeline="timeline"
            @navigate="ASSETS.Timeline.Navigation.Navigate(this, $event)"
            @configure="ASSETS.Timeline.Configure(this, $event)"
            @max-topography="SetTimelineProjectsMaxTopography($event)"
        />

        <!-- Non-timeline project view -->
        <ProjectList
            v-if="(projectViewType.view === 'List' || platform.mobile) && loaded"
            :projects="projectList"
            :mobile="platform.mobile"
            :selectedProject="{}"
            :projectTypes="timeline.projectTypes"
        />

        <Settings :topography="timelineProjectsMaxTopography" @select="SETTINGS.Select(this, $event)"/>
    </div>
</template>

<script>
import Header from "@/components/Template/Header.vue";
import PriorityButton from "@/components/Projects/PriorityButton.vue";
import Timeline from "@/components/Timeline/Timeline.vue";
import Logo from "@/components/Logo.vue";
import ViewToggle from "@/components/Projects/ViewToggle/ViewToggle.vue";
import ProjectList from "@/components/Projects/CategoryList/Projects.vue";
import Settings from "@/components/Settings/Settings.vue";
import ProfilePaletteSummary from "@/components/Profile/PaletteSummary/PaletteSummary.vue";
import Navigation from "@/assets/JS/Data/Navigation.json";
import { READ } from "@/data/Read.js";
import DataAPI from "@/data/API.js";
import {
    CONFIG,
    profile
} from "@/assets/JS/Config.js";
import {
    viewModel,
    timelineModel,
    settingsModel,
    searchModel
} from "@/models/";
import { TimelineInstance } from "@/assets/JS/Timeline.js";
import {
    ASSETS,
    PROJECT_VIEW_TYPES,
    PROJECT_PRIORITY_TYPE,
    SETTINGS,
    PROFILES
} from "@/assets/JS/Assets.js";
import { Animation } from "@/assets/JS/Animation.js";
import { MASTER } from "@/assets/JS/Master.js";
import $ from "jquery";
import store from "@/store";

export default {
    name: "ViewMain",
    props: { ...viewModel.props },
    components: {
        Header,
        PriorityButton,
        Timeline,
        Logo,
        ViewToggle,
        ProjectList,
        Settings,
        ProfilePaletteSummary
    },
    data: () => ({
        Navigation,
        projectDateRange: {},
        CONFIG,
        ASSETS,
        welcomeComplete: false,
        SETTINGS,
        ...timelineModel(CONFIG),
        ...viewModel.data,
        ...settingsModel.data,
        ...searchModel.data,
        timelineProjectsMaxTopography: 0,
        analysis: {
            palette: { usage: {} }
        },
        PROFILES,
        profile
    }),
    methods: {
        FrameID: function() { return this.welcomeComplete ? "frame" : "frame-welcome"; },
        WelcomeComplete: function() { this.welcomeComplete = true; },
        SelectProjectPriorityType: async function(priorityType) {
            priorityType = priorityType.PriorityType;
            if (!this.platform.mobile) {
                this.timeline.priority = {
                    selected: true,
                    type: priorityType
                };
                this.timeline.configurations.enabled = true;

                // Scroll to timeline after focus
                let $projectsContent = null;
                const $timeline = $("#timeline");
                const $projectList = $("#project-list");
                if ($("#timeline").length) {
                    $projectsContent = $timeline;
                }
                if ($("#project-list").length) {
                    $projectsContent = $projectList;
                }
                new Animation(
                    $("html"),
                    "Scroll Top",
                    $projectsContent.offset().top,
                    750,
                    0
                );

                await ASSETS.Timeline.Load(
                    this,
                    true,
                    {
                        READ,
                        DataAPI
                    },
                    store
                );
                this.timeline.priority.counts = await READ.Counts(this, DataAPI);
            } else {

                // Scroll to project list after focus
                const $priorityType = priorityType === PROJECT_PRIORITY_TYPE.Focus
                    ? $("#category-focus")
                    : $("#category-archive");
                new Animation(
                    $("html"),
                    "Scroll Top",
                    $priorityType.offset().top,
                    750,
                    0
                );

            }
        },
        ShowAttachedTimeline: function() {
            return ASSETS.Timeline.Show(this, this.timeline.configurations.attached) &&
                !this.platform.mobile &&
                this.timeline.data;
        },
        ShowDetachedTimeline: function() {
            const {
                configurations,
                data,
                projectTypes,
                distinctProjectTypes
            } = this.timeline;
            const projectTypesLoaded = projectTypes.length > 0 && distinctProjectTypes.length > 0;
            return ASSETS.Timeline.Show(this, !configurations.attached) &&
                this.loaded &&
                this.projectViewType.view === "Timeline" &&
                !this.platform.mobile &&
                data &&
                projectTypesLoaded;
        },
        SetTimelineProjectsMaxTopography: function(maxTopography) {
            this.timelineProjectsMaxTopography = maxTopography + 700;
        }
    },
    beforeMount: async function() {
        MASTER.Construct($);
        ASSETS.Construct($, Animation);
        ASSETS.Timeline.SetConfigurations(this);

        // Set portfolio data cache
        let portfolio = ASSETS.GetStorage("Portfolio");
        if (portfolio === null) {
            ASSETS.SetStorage("Portfolio", store.state);
            portfolio = ASSETS.GetStorage("Portfolio");
            portfolio.settings.projectViewType.view = PROJECT_VIEW_TYPES.timeline;
        } else {
            if (portfolio.settings.projectViewType.view === "") {
                portfolio.settings.projectViewType.view = PROJECT_VIEW_TYPES.timeline;
            }
            store.state.settings.projectViewType = ASSETS.Projects.ViewType(portfolio.settings);
        }
        this.projectViewType = ASSETS.Projects.ViewType(portfolio.settings);

        if (portfolio.loaded) {
            this.welcomeComplete = true;
        }
    },
    mounted: async function() {
        this.$emit("start-loader", "#app");

        // Set IDs for priority types
        let p = 0;
        for (const priorityType of Navigation.Projects.PriorityTypes) {
            p++;
            priorityType.ID = p;
        }

        this.platform.mobile = MASTER.Platform._mobile;
        
        // Get timeline data
        const api = {
            READ,
            DataAPI
        };
        if (!this.platform.mobile) {
            await ASSETS.Timeline.Get(
                this,
                api,
                TimelineInstance,
                Navigation.Projects.PriorityTypes,
                CONFIG
            );
            await ASSETS.Timeline.Load(this, false, api, store);
            this.timeline.configurations.enabled = false;
        } else {
            await ASSETS.Mobile.LoadProjects(this, api, store);
        }

        this.timeline.priority.counts = await READ.Counts(this, DataAPI);
        this.timeline.distinctProjectTypes = await READ.DistinctTypes(this, DataAPI);
        this.timeline.projectTypes = await READ.ProjectTypes(this, DataAPI);
        this.analysis.palette.usage = await READ.AnalysisUsageProfile(this, DataAPI);

        // Assign content as profile
        this.$emit("sub-navigation-navigate", this.$route.meta.profileContent.content);

        this.projectList = await READ.ProjectListByCategory(this, DataAPI);
        this.$emit("stop-loader");
    },
    emits: [ ...viewModel.emits ]
};
</script>